import { render, staticRenderFns } from "./PackshotBasketButton.vue?vue&type=template&id=021c31c4&"
import script from "./PackshotBasketButton.vue?vue&type=script&lang=js&"
export * from "./PackshotBasketButton.vue?vue&type=script&lang=js&"
import style0 from "./PackshotBasketButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports